<template>
  <div class="courseInfo">
    <!-- 循环我的课程 -->
    <div class="courseTitle" v-for="(item, i) in dataCourse" :key="i">
      <h3 class="flex_center"><img :src="item.img" />{{item.subtitle}}</h3>
      <p class="typeStud">{{item.leveltitle}}</p>
      <p class="color_main nextLess">Next lesson: {{item.next_at_format}}</p>
      <div style="margin-bottom: 50px">
        <p class="font_14 color_grey m24">Weekly Schedule</p>
        <div v-for="(timeItem, j) in item.settingFormat"  :key="j">
          <p class="font_16" style="margin-bottom: 4px">Every {{timeItem.weekday}} - {{timeItem.start_at}}</p>
        </div>
      </div>
      <div class="lineHeigh">
        <div>
          <p class="font_16">Duration: {{item.duration}} mins</p>
        </div>
        <div class="flex_justify_end">
          <button :class="item.status==0?'Not_Started':(item.status==1?'In_progress':'Completed')">
            {{item.status==0?'Not Started':(item.status==1?'In progress':'Completed')}}
          </button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataCourse: Array,
    required: true
  },
  created () {
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.courseInfo{
  display: flex;
  flex-wrap: wrap;
  .courseTitle{
    background: #FFFFFF;
    margin:0px 24px 24px 0;
    width: 268px;
    border-radius: 16px;
    /* 自动布局 */
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 0px 10px;
    flex-wrap: nowrap;
    align-content: flex-start;
    position: relative;
    border: 1px solid #DDDDDD;
    border-radius: 16px;
    &:nth-child(3n+0){
      margin-right:0;
    }
    h3{
      font-size: 18px;
      line-height: 28px;
      font-weight: normal;
      img{
        width:40px;
        height:40px;
        margin-right:12px;
      }
    }
    .typeStud{
      padding:16px 0;
      color: #666;
      font-size: 14px;
      line-height: 20px;
    }
    .nextLess{
      white-space:nowrap;
      font-family: Arial;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #FF904D !important;
    }
    .font_16{
      font-family: Arial;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      letter-spacing: 0px;

      color: #666666;
    }
    .m24{
      margin-top:24px;
      font-family: Arial;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      letter-spacing: 0px;
      margin-bottom: 8px;
      color: #333333;
    }
    /deep/.lineHeigh{
      line-height: 24px;
      margin-top: 24px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      align-items: center;
      position: absolute;
      bottom: 14px;
      width: 272px;
      .flex_justify_end{
        /* 自动布局 */
        display: flex;
        flex-direction: column;
        gap: 0px 10px;
        flex-wrap: wrap;
        align-content: flex-start;
        border-radius: 8px;
        .Not_Started{
          background: #FEF9C3;
          color: #CA8A04;
          width: 103.47px;
          height: 36px;
          border-radius: 8px;
          border: none;
        }
        .In_progress{
          background: #D4F5E3;
          color: #29CE73;
          width: 103.47px;
          height: 36px;
          border-radius: 8px;
          border: none;
        }
        .Completed{
          background: #DBEAFE;
          color: #2563EB;
          width: 103.47px;
          height: 36px;
          border-radius: 8px;
          border: none;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/views/course.vue